import { EditorField } from '@src/main/shared/ui/components/input/EditorField';
import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { FC } from 'react';
import styles from './ReleaseNoteByodForm.module.scss';

interface ReleaseNoteByodFormProps {
  values: {
    releaseNoteByodId?: string | number;
    version: string;
    description: string;
  };
  handleChange: <K extends keyof ReleaseNoteByodFormProps['values']>(
    field: K,
    value: ReleaseNoteByodFormProps['values'][K],
  ) => void;
  errors?: Record<string, string>;
}

const ReleaseNoteByodForm: FC<ReleaseNoteByodFormProps> = ({ values, handleChange, errors }) => (
  <form className={styles.grid}>
    <div className={styles.field}>
      <FloatLabelInput
        label="Versión"
        value={values.version}
        onChange={(val) => handleChange('version', val)}
        error={errors?.version}
        inputClassName={styles.inputfield}
        disabled={!!values.releaseNoteByodId}
      />
    </div>

    <div className={styles.field}>
      <EditorField
        label="Descripción"
        value={values.description}
        onChange={(val) => handleChange('description', val)}
        error={errors?.description}
        styles={styles}
      />
      {errors?.description && <span className={styles['p-error']}>{errors.description}</span>}
    </div>
  </form>
);

export default ReleaseNoteByodForm;
